import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import WizardListPage from './pages/WizardListPage';

function WizardFeature() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path}>
        <WizardListPage />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default WizardFeature;
